module.exports = __webpack_public_path__ + "static/media/bags3.e39d355b.jpg";